import 'babel-polyfill';
import Vue from 'vue';
require('./plugins/barcodeUpdater');
import { tryGetMacAddress } from './plugins/macAddressResolver';
import { isElectronContext } from './utils/isElectron';

listenBearer();

const isElectron = isElectronContext() || typeof Epos_Android_Interface != 'undefined';


import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

if (process.env.NODE_ENV !== 'development') {
  let sentryURL = window.location.hostname.replace('engine.', '');
  sentryURL = sentryURL.replace('kiosk.', '');

  /*Sentry.init({
    dsn: 'https://709c67b408214cd3892560ab38236263@sentry.' + sentryURL + '/14',
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    environment: isElectron ? `kiosk` : `instabet`,
  });*/
}

tryGetMacAddress();

import App from './App.vue';
import router from './router/index';
import store from './store/index';
import i18n from './utils/i18n';

/** 3rd Parts **/
import Vuelidate from 'vuelidate';
// import moment from 'vue-moment'
require('moment/locale/es');
require('moment/locale/pt-br');
require('moment-timezone');
import Vuebar from 'vuebar';
import Toasted from 'vue-toasted';
import '@/plugins/cssua';
// ios
import native from '@/plugins/native';
import PortalVue from 'portal-vue';
//

/** Directives **/
import CapitalizeTextDirective from './utils/directives/capitalize-text-directive';
import HighlightText from './utils/directives/highlight-text';
import ClickOutsideDirective from './utils/directives/click-outside-directive';

/** 3rd Parts **/
Vue.use(Vuelidate);
import Maska from 'maska';
Vue.use(Maska);

import VueMoment from './plugins/vue-moment';

Vue.use(VueMoment);
import cssVars from 'css-vars-ponyfill';

cssVars({});

import zendeskController from '@/utils/zendeskController';
import headerController from '@/utils/headerController';
import pixelad from '@/utils/pixelad';
import gestrk from '@/utils/gestrk';
// Vue.use(moment,{locale: 'es'});
Vue.use(Vuebar);
Vue.use(Toasted /*,OPTIONS*/);
Vue.use(PortalVue /*,OPTIONS*/);

import { TooltipPlugin } from 'bootstrap-vue';
Vue.use(TooltipPlugin);
/** Global Components **/
Vue.component('app-header', () => import('./components/shared/Header.vue'));
Vue.component('app-footer', () => import('./components/shared/Footer.vue'));
Vue.component('app-breadcrumb', () => import('./components/shared/BreadCrumb.vue'));
Vue.component('app-casinobreadcrumb', () => import('./components/shared/CasinoBreadCrumb.vue'));
Vue.component('confirm-modal', () => import('./components/shared/ConfirmModal.vue'));
Vue.component('form-group-item', () => import('./components/shared/FormGroupItem.vue'));
Vue.component('error-message', () => import('./components/shared/ErrorMessage.vue'));
Vue.component('modal', () => import('./components/shared/Modal.vue'));
Vue.component('modal2', () => import('./components/shared/Modal2.vue'));
Vue.component('base-page', () => import('./components/shared/BasePage.vue'));
Vue.component('custom-switch', () => import('./components/shared/CustomSwitch.vue'));
Vue.component('custom-checkbox', () => import('./components/shared/CustomCheckbox.vue'));
Vue.component('alert-message', () => import('@/components/shared/AlertMessage'));
Vue.component('bet-alert-message', () => import('@/components/shared/BetAlertMessage'));
Vue.component('app-rollover', () => import('./components/shared/Rollover.vue'));
Vue.component('price', () => import('./components/shared/Price.vue'));
Vue.component('CdevSeeMore', () => import('./components/shared/CdevSeeMore'));
Vue.component('CdevButton', () => import('./components/shared/CdevButton'));
Vue.component('CdevInputWithIcon', () => import('./components/shared/CdevInputWithIcon'));
Vue.component('CdevDivider', () => import('./components/shared/CdevDivider'));
Vue.component('CdevModal', () => import('./components/shared/CdevModal'));

/** Directives **/
Vue.directive('capitalize-text', CapitalizeTextDirective);
Vue.directive('highlight-text', HighlightText);
Vue.directive('click-outside', ClickOutsideDirective);

/** Vue Config **/
Vue.prototype.$enviroment = process.env;
Vue.prototype.$cdn = process.env.VUE_APP_CDN_URL;
Vue.config.productionTip = false;

Vue.prototype.$native = native;

import gtmProvider from './utils/gtmProvider';
import gaHelper from './utils/gaHelper';
import statscoreHelper from '@/views/statscore/utils/statscoreHelper';
import TaxHelper from '@/utils/taxHelper';

Vue.prototype.$statscoreHelper = new statscoreHelper();
Vue.prototype.$taxHelper = new TaxHelper();

import VueAnalytics from 'vue-analytics';
import { listenBearer } from './utils/listenBearer';

const uaID = window.location.hostname.includes('instabet.mx')
  ? 'UA-166344427-1'
  : window.location.hostname.includes('instabet.net')
  ? 'UA-166475412-1'
  : window.location.hostname.includes('instabet.com')
  ? 'UA-166350914-1'
  : null;
  
  let engineFv3 = window.location.hostname.includes('engine-fv3');
if (uaID && !isElectron && !engineFv3) {
  Vue.use(VueAnalytics, {
    id: uaID, // TODO IT WILL BE COME FROM BRAND SETTINGS
    router,
  });
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
